module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURUdwTOtxN+txN+txN+txN+txN+txN+txN+txN+txN+txN3sA0MAAAAAKdFJOUwDLGm7wB1M6nLLQrY0TAAAACXBIWXMAAABIAAAASABGyWs+AAAAh0lEQVQY02NgCBZZBQaOpgwMTFKroGChAkPgKjgQZbBCcBYzgFWJa4DVMYBIZwaGFBAN4qxUAJozC8JZksAABGxeYE4rAxhogjjLIWwGVisgZzGUw5AFUiYEYWtADDBAMmDVAhCHa5UWMocLJwdFGcQAsLVVQGMZpBD+WYjqORRvowQIclABADq+eNQiVhdtAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/school/level.png
// module id = 218
// module chunks = 0